
<template>

  <v-container
  >
  <div style="    text-align: center;margin-bottom: 5%">
    <img
            :src="appLogo"
            style="width: 16%;"
            class="img-responsive center mb-3"

    />
  </div>

    <v-layout wrap>
      <v-flex
              md12
              xs12
              lg3
      >
        </v-flex>
      <v-flex
              md12
              xs12
              lg6
      >
        <v-form
                align="center"
                v-model="valid" class="mb-4" @keyup.native.enter="valid">
          <v-flex col-md-5>
            <v-text-field
                    label="E-mail ID"
                    v-model="email"
                    type="email"
                    :rules="emailRules"
                    required
            ></v-text-field>
          </v-flex>

          <v-flex>
            <v-btn @click="submit" :disabled="!email"  color="primary">Forget Password</v-btn>
            <!-- <v-btn large @click="onCreateAccount" block color="warning">{{$t('message.createAccount')}}</v-btn> -->
          </v-flex>
          <!-- <p>{{$t('message.bySigningUpYouAgreeTo')}} {{brand}}</p> -->
          <!-- <router-link to="">{{$t('message.termsOfService')}}</router-link> -->
        </v-form>
      </v-flex>
    </v-layout>

  </v-container>
</template>


<script>

  import AppConfig from "../constants/AppConfig";
  import api from '../api';
  import { forgetPassword } from '../api/routes';
  import router from 'vue-router'

  // import AuthService from "../../auth/AuthService";

  // const auth = new AuthService();
  // const { login, logout, authenticated, authNotifier } = auth;

  export default {
    data() {

      return {
        checkbox: false,
        valid: false,
        appLogo: "/img/logo.png",
        email: "",
        emailRules: [
          v => !!v || "E-mail is required",
          v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
        ],
        password: "",
        passwordRules: [
            v => !!v || "Password is required"
        ],
      };
    },
    mounted(){},
    methods: {

      submit(event) {
          const user = {
              email: this.email,
              callback_url: window.location.origin+'/session/reset-password',
          };
          forgetPassword(user)
                .then(response => {
                    response =response.data;
                    console.log(response);
                    this.$toasted.show(response);
                    this.$router.push("/session/login");
                })
                .catch(error => {
                  console.log(error)
                    this.$toasted.show(error.response.data.message)
                });
      },

    }
  };
</script>
<style  scoped>
  .center {
  margin: auto;


}
</style>
